// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2L9Ay","title":"InfoRow_title__1oB-L"};